// Shared wording and colours for the office board and the driver preview.
// Values match AvailabilityState.java and worker_availability.availabilityState.
export const availabilityStates = {
  UNKNOWN: { label: 'No declaration', hint: 'Brak deklaracji', color: '#64748b', background: '#f3f6fa' },
  AVAILABLE: { label: 'Available', hint: 'Dostępny, chcę pracować', color: '#176a4d', background: '#eaf8f0' },
  UNAVAILABLE: { label: 'Unavailable', hint: 'Niedostępny, nie chcę pracować', color: '#a1404f', background: '#fff0f2' },
  STANDBY: { label: 'Standby', hint: 'Mogę pracować w ostateczności', color: '#745482', background: '#f5eff8' },
  VACATION: { label: 'Vacation', hint: 'Zgłaszam dzień urlopu', color: '#246c8b', background: '#edf8fc' },
};
export const driverSelectableStates = ['AVAILABLE', 'UNAVAILABLE', 'VACATION', 'STANDBY'];
